import React, {Component} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import Container from "../../../../modules/commons/Container";
import ReceivingUnitDGI from "./receivingUnitDGI/receivingUnitDGI";
import ReceivingUnitNOS from "./receivingUnitNOS/receivingUnitNOS";

class ReceivingUnit extends Component {
    render() {
        return (
            <Container>
                <Tabs>
                    <TabList>
                        <Tab id="button_navigate_dgi">DGI</Tab>
                        <Tab id="button_navigate_nos">NOS</Tab>
                    </TabList>
                    <TabPanel>
                        <ReceivingUnitDGI {...this.props} />
                    </TabPanel>
                    <TabPanel>
                        <ReceivingUnitNOS {...this.props} />
                    </TabPanel>
                </Tabs>
            </Container>
        );
    }
}

export default ReceivingUnit;
